// src/components/DataFilters.jsx
import React from 'react';
import { FaSearch, FaRedo, FaFileExport } from 'react-icons/fa';

const DataFilters = ({
  filters,
  onFilterChange,
  onReset,
  onExport,
  exporting,
  showResultFilter = true,
  showPageSize = true,
  exportLabel = "导出数据"
}) => {
  return (
    <div className="filters-container">
      <div className="filter-row">
        <div className="filter-group">
          <label htmlFor="startTime">
            <FaSearch className="filter-icon" />
            起始时间
          </label>
          <input
            type="datetime-local"
            id="startTime"
            name="startTime"
            value={filters.startTime}
            onChange={onFilterChange}
          />
        </div>
        
        <div className="filter-group">
          <label htmlFor="endTime">
            <FaSearch className="filter-icon" />
            终止时间
          </label>
          <input
            type="datetime-local"
            id="endTime"
            name="endTime"
            value={filters.endTime}
            onChange={onFilterChange}
          />
        </div>
        
        <div className="filter-group">
          <label htmlFor="keyword">
            <FaSearch className="filter-icon" />
            关键字搜索
          </label>
          <input
            type="text"
            id="keyword"
            name="keyword"
            placeholder="学号/姓名/手机号"
            value={filters.keyword}
            onChange={onFilterChange}
          />
        </div>
        
        {showResultFilter && (
          <div className="filter-group">
            <label htmlFor="rstCode">
              <FaSearch className="filter-icon" />
              认证结果
            </label>
            <select
              id="rstCode"
              name="rstCode"
              value={filters.rstCode}
              onChange={onFilterChange}
            >
              <option value="all">全部状态</option>
              <option value="0">未认证</option>
              <option value="1">认证成功</option>
              <option value="2">认证失败</option>
            </select>
          </div>
        )}
        
        {showPageSize && (
          <div className="filter-group">
            <label htmlFor="pageSize">
              <FaSearch className="filter-icon" />
              每页显示
            </label>
            <select
              id="pageSize"
              name="pageSize"
              value={filters.pageSize}
              onChange={onFilterChange}
            >
              <option value="5">5条</option>
              <option value="10">10条</option>
              <option value="20">20条</option>
              <option value="50">50条</option>
            </select>
          </div>
        
        )}
        
        <div className="filter-actions">
          <button className="reset-btn" onClick={onReset}>
            <FaRedo className="action-icon" />
            重置
          </button>
          <button
            className="export-btn"
            onClick={onExport}
            disabled={exporting}
          >
            {exporting ? (
              <>
                <span className="spinner"></span> 导出中...
              </>
            ) : (
              <>
                <FaFileExport className="action-icon" />
                {exportLabel}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataFilters;